
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    function onClick1(showEditorInitially) {
        window.Convermax.setVehicleWidgetDialogView('garage');
    }
    function onClick2(showEditorInitially) {
        window.Convermax.setVehicleWidgetDialogView('garage');
    }
    function scopeShowEditorInitially3() {
        var showEditorInitially = this.isGarageEmpty || this.isSpecifyDialog;
        return _createElement('div', { 'className': 'dialog-container cm_dialog-drawer' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', {
            'className': 'dialog-header',
            'data-cm-vehicle-dialog-header': true
        }, _createElement('div', {
            'className': 'dialog-title',
            'data-cm-vehicle-dialog-title': 'garage',
            'hidden': showEditorInitially
        }, '\n        ', _translate(`vehicle_dialog_garage_title`), '\n      '), !showEditorInitially ? _createElement('button', {
            'className': 'cm_vehicle-dialog_back',
            'type': 'button',
            'aria-label': _translate(`vehicle_dialog_back`),
            'data-cm-vehicle-dialog-editor-control': true,
            'hidden': true,
            'onClick': onClick1.bind(this, showEditorInitially),
            'key': '396'
        }, [_createElement('svg', {
                'className': 'cm_icon cm_icon-angle left',
                'height': '20px',
                'role': 'img',
                'viewBox': '39 30 565 565',
                'aria-hidden': 'true',
                'key': '6710'
            }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))]) : null, _createElement('div', {
            'className': 'dialog-title',
            'data-cm-vehicle-dialog-title': 'editor-add',
            'hidden': !showEditorInitially
        }, '\n        ', _translate(`garage_add_button`), '\n      '), _createElement('div', {
            'className': 'dialog-title',
            'data-cm-vehicle-dialog-title': 'editor-edit',
            'hidden': true
        }, '\n        ', _translate(`vehicle_dialog_edit`), '\n      '), _createElement('div', {
            'className': 'dialog-header-close',
            'data-cm-role': 'close',
            'onClick': this.close
        }, [_createElement('svg', {
                'className': 'cm_icon cm_icon-times',
                'height': '20px',
                'role': 'img',
                'viewBox': '0 0 22 22',
                'key': '13780'
            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])), _createElement('div', {
            'className': 'dialog-body',
            'data-cm-vehicle-dialog-view': 'garage',
            'hidden': showEditorInitially
        }, [this.vehicleList(function () {
                function repeatItems1(items, itemsIndex) {
                    return [items(function () {
                            function onClick1() {
                                window.Convermax.removeVehicleFromDialogGarage(this.removeVehicle);
                            }
                            function onClick2() {
                                window.Convermax.setVehicleWidgetDialogView('edit');
                            }
                            return this.isSelected ? _createElement('div', {
                                'className': 'cm_vehicle-dialog_vehicle cm_vehicle-dialog_vehicle__selected',
                                'key': '11'
                            }, [
                                _createElement('div', {
                                    'className': 'cm_vehicle-dialog_vehicle-row',
                                    'key': '1101'
                                }, _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-select',
                                    'type': 'button',
                                    'onClick': this.selectVehicle
                                }, _createElement('div', { 'className': 'cm_vehicle-dialog_vehicle-base' }, this.vehicleBaseValues.join(' ')), _createElement('div', { 'className': 'cm_vehicle-dialog_vehicle-extra' }, this.vehicleExtraValues.join(' \u2022 '))), _createElement('label', { 'className': 'cm_vehicle-dialog_vehicle-disclosure' }, _createElement('input', {
                                    'type': 'checkbox',
                                    'aria-label': _translate(`vehicle_dialog_toggle_actions`)
                                }), _createElement('span', { 'className': 'cm_vehicle-dialog_vehicle-disclosure-icon' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-angle down',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '39 30 565 565',
                                        'aria-hidden': 'true',
                                        'key': '7140'
                                    }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))]))),
                                _createElement('div', {
                                    'className': 'cm_vehicle-dialog_vehicle-actions',
                                    'key': '1103'
                                }, _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-delete',
                                    'type': 'button',
                                    'onClick': onClick1.bind(this)
                                }, '\n      ', _translate(`vehicle_dialog_delete`), '\n    '), this.isSelected ? _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-edit',
                                    'type': 'button',
                                    'onClick': onClick2.bind(this),
                                    'key': '1309'
                                }, '\n      ', _translate(`vehicle_dialog_edit`), '\n    ') : null)
                            ]) : null;
                        }, { count: undefined })];
                }
                function repeatItems2(items, itemsIndex) {
                    return [items(function () {
                            function onClick1() {
                                window.Convermax.removeVehicleFromDialogGarage(this.removeVehicle);
                            }
                            function onClick2() {
                                window.Convermax.setVehicleWidgetDialogView('edit');
                            }
                            return !this.isSelected ? _createElement('div', {
                                'className': 'cm_vehicle-dialog_vehicle',
                                'key': '11'
                            }, [
                                _createElement('div', {
                                    'className': 'cm_vehicle-dialog_vehicle-row',
                                    'key': '751'
                                }, _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-select',
                                    'type': 'button',
                                    'onClick': this.selectVehicle
                                }, _createElement('div', { 'className': 'cm_vehicle-dialog_vehicle-base' }, this.vehicleBaseValues.join(' ')), _createElement('div', { 'className': 'cm_vehicle-dialog_vehicle-extra' }, this.vehicleExtraValues.join(' \u2022 '))), _createElement('label', { 'className': 'cm_vehicle-dialog_vehicle-disclosure' }, _createElement('input', {
                                    'type': 'checkbox',
                                    'aria-label': _translate(`vehicle_dialog_toggle_actions`)
                                }), _createElement('span', { 'className': 'cm_vehicle-dialog_vehicle-disclosure-icon' }, [_createElement('svg', {
                                        'className': 'cm_icon cm_icon-angle down',
                                        'height': '20px',
                                        'role': 'img',
                                        'viewBox': '39 30 565 565',
                                        'aria-hidden': 'true',
                                        'key': '6790'
                                    }, _createElement('path', { 'd': 'M600,189q0-7-6-12l-28-28q-5-6-12-6t-13,6l-220,219-219-219q-5-6-13-6t-12,6l-28,28q-6,5-6,12t6,13l260,260q5,6,12,6t13-6l260-260q6-5,6-13z' }))]))),
                                _createElement('div', {
                                    'className': 'cm_vehicle-dialog_vehicle-actions',
                                    'key': '753'
                                }, _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-delete',
                                    'type': 'button',
                                    'onClick': onClick1.bind(this)
                                }, '\n      ', _translate(`vehicle_dialog_delete`), '\n    '), this.isSelected ? _createElement('button', {
                                    'className': 'cm_vehicle-dialog_vehicle-edit',
                                    'type': 'button',
                                    'onClick': onClick2.bind(this),
                                    'key': '1274'
                                }, '\n      ', _translate(`vehicle_dialog_edit`), '\n    ') : null)
                            ]) : null;
                        }, { count: undefined })];
                }
                function onClick3() {
                    window.Convermax.setVehicleWidgetDialogView('add', this.size);
                }
                return _createElement('div', { 'className': 'cm_vehicleList' }, this.isVehicleSelected ? _createElement('div', {
                    'className': 'cm_vehicle-dialog_section-title',
                    'key': '37'
                }, '\n          ', _translate(`vehicle_dialog_current_vehicle`), '\n        ') : null, _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_items' },
                    _map(this.items, repeatItems1.bind(this))
                ]), this.size > 1 || !this.isVehicleSelected ? _createElement('div', {
                    'className': 'cm_vehicle-dialog_section-title cm_vehicle-dialog_section-title__other',
                    'key': '2985'
                }, '\n          ', _translate(`vehicle_dialog_other_vehicles`), '\n        ') : null, _createElement.apply(this, [
                    'div',
                    { 'className': 'cmRepeater_items' },
                    _map(this.items, repeatItems2.bind(this))
                ]), _createElement('button', {
                    'className': 'cm_vehicle-widget_button button',
                    'type': 'button',
                    'onClick': onClick3.bind(this)
                }, '\n          ', _translate(`garage_add_button`), '\n        '), _createElement('button', {
                    'className': 'cm_vehicle-dialog_shop-without-vehicle',
                    'type': 'button',
                    'onClick': this.discardVehicle
                }, '\n          ', _translate(`vehicle_dialog_shop_without_vehicle`), '\n        '));
            }, {
                widgetName: 'undefined',
                items: undefined
            })]), _createElement('div', {
            'className': 'dialog-body',
            'data-cm-vehicle-dialog-view': 'editor',
            'hidden': !showEditorInitially
        }, [this.vehicleWidget(function () {
                function repeatSelects1(selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n              ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n            ');
                            }
                            function repeatEntry2(isQualifierField, popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                            }
                            function scopePopularEntriesUnpopularEntriesIsPopularField3(isQualifierField) {
                                var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                                var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                                var isPopularField = popularEntries.length && unpopularEntries.length;
                                return [
                                    !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                        'value': '',
                                        'key': 'null-option'
                                    }, '\n            ', _translate(`select_title`), ' ', this.title, '\n          ') : null,
                                    this.loading ? _createElement('option', {
                                        'key': 'loading-option',
                                        'disabled': true
                                    }, _translate(`select_loading`)) : null,
                                    isPopularField ? [
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-popular',
                                            'disabled': true,
                                            'key': '13431'
                                        }, _translate(`ymm_bar_popular`)),
                                        _map(popularEntries, repeatEntry1.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField)),
                                        _createElement('option', {
                                            'className': 'cm_option_title cm_option-unpopular',
                                            'disabled': true,
                                            'key': '13434'
                                        }, _translate(`ymm_bar_unpopular`))
                                    ] : null,
                                    _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, isQualifierField, popularEntries, unpopularEntries, isPopularField))
                                ];
                            }
                            function scopeShowSelectedValues4(isQualifierField) {
                                var showSelectedValues = this.selectedEntries.length;
                                return _createElement('option', {
                                    'key': '_current',
                                    'value': '_current'
                                }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                    _translate(`select_title`),
                                    ' ',
                                    this.title
                                ] : null);
                            }
                            function repeatEntry5(isQualifierField, entry, index) {
                                return _createElement('div', {
                                    'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                    'key': entry.value,
                                    'onClick': () => this.onChange(entry.term)
                                }, this.showCheckboxes ? _createElement('input', {
                                    'type': 'checkbox',
                                    'readOnly': true,
                                    'checked': entry.selected,
                                    'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                    'key': '3617'
                                }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                    'className': 'cm_dropdown_hitCount',
                                    'key': '3823'
                                }, entry.hitCount) : null);
                            }
                            function mergeProps(inline, external) {
                                var res = Object.assign({}, inline, external);
                                if (inline.hasOwnProperty('style')) {
                                    res.style = _.defaults(res.style, inline.style);
                                }
                                if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                    res.className = external.className + ' ' + inline.className;
                                }
                                return res;
                            }
                            function scopeDescription7(isQualifierField) {
                                var description = _translate(`facet_details_${ this.field }`);
                                return [description ? _createElement('div', {
                                        'className': 'cm_select-qualifier-details',
                                        'key': '43591'
                                    }, _createElement('button', { 'className': 'cm_select-qualifier-details_button' }, [_createElement('svg', {
                                            'width': '24',
                                            'height': '24',
                                            'viewBox': '0 0 24 24',
                                            'fill': 'none',
                                            'xmlns': 'http://www.w3.org/2000/svg',
                                            'key': '45860'
                                        }, _createElement('g', { 'opacity': '0.6' }, _createElement('circle', {
                                            'cx': '12',
                                            'cy': '12',
                                            'r': '11.5',
                                            'stroke': 'black'
                                        }), _createElement('path', {
                                            'd': 'M12.768 14.72H11.28C11.28 13.8453 11.6267 13.0613 12.32 12.368C12.384 12.304 12.5867 12.112 12.928 11.792C13.28 11.4613 13.5093 11.232 13.616 11.104C13.7333 10.9653 13.8613 10.7573 14 10.48C14.1493 10.2027 14.224 9.936 14.224 9.68C14.224 9.15733 14.0427 8.752 13.68 8.464C13.3173 8.176 12.8373 8.032 12.24 8.032C11.0667 8.032 10.3147 8.54933 9.984 9.584L8.72 8.88C8.976 8.15467 9.41867 7.59467 10.048 7.2C10.688 6.79467 11.424 6.592 12.256 6.592C13.1947 6.592 14.0053 6.85867 14.688 7.392C15.3707 7.91467 15.712 8.656 15.712 9.616C15.712 10.448 15.3653 11.2107 14.672 11.904C14.6187 11.9573 14.4533 12.1173 14.176 12.384C13.8987 12.64 13.712 12.8267 13.616 12.944C13.52 13.0507 13.3867 13.216 13.216 13.44C13.0453 13.664 12.928 13.8773 12.864 14.08C12.8 14.2827 12.768 14.496 12.768 14.72ZM12.016 18.176C11.728 18.176 11.4827 18.0747 11.28 17.872C11.0773 17.6693 10.976 17.424 10.976 17.136C10.976 16.848 11.0773 16.6027 11.28 16.4C11.4827 16.1973 11.728 16.096 12.016 16.096C12.3147 16.096 12.56 16.1973 12.752 16.4C12.9547 16.6027 13.056 16.848 13.056 17.136C13.056 17.424 12.9547 17.6693 12.752 17.872C12.56 18.0747 12.3147 18.176 12.016 18.176Z',
                                            'fill': 'black'
                                        })))]), _createElement('div', { 'className': 'cm_select-qualifier-details_content' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-details_content-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_select-qualifier-details_content-text' }, description))) : null];
                            }
                            function repeatEntry8(isQualifierField, entry, entryIndex) {
                                return _createElement('div', {
                                    'key': entry.value,
                                    'className': 'cm_select-qualifier-value' + (entry.selected ? ' cm_select-qualifier-value_selected' : ''),
                                    'onClick': () => this.onChange(entry.term)
                                }, '\n          ', entry.value, '\n        ');
                            }
                            function scopeIsQualifierField9() {
                                var isQualifierField = this.field?.startsWith('Qualifier_');
                                return _createElement('div', { 'className': this.extraClassName + (isQualifierField ? ' cm_select-qualifier-container' : '') }, !isQualifierField ? [
                                    !this.isSearchable ? _createElement('div', {
                                        'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                                        'key': '1951'
                                    }, _createElement('select', {
                                        'className': 'cm_select_inner-select cm_form-select form-select form-select--small',
                                        'onChange': this.onChange,
                                        'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                        'disabled': this.disabled,
                                        'aria-label': this.title
                                    }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, [isQualifierField]) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, [isQualifierField]) : null)) : null,
                                    this.isSearchable ? [[this.filterInput(function () {
                                                return _createElement('div', { 'className': 'cm_filterInput' });
                                            }, {
                                                widgetName: 'undefined',
                                                items: undefined
                                            })]] : null,
                                    !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                                        'div',
                                        {
                                            'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                            'aria-label': this.title,
                                            'key': '1955'
                                        },
                                        !this.hideNullOption ? _createElement('div', {
                                            'className': 'option',
                                            'key': 'null-option',
                                            'onClick': () => this.onChange('')
                                        }, '\n        ', _translate(`select_title`), ' ', this.title, '\n      ') : null,
                                        this.loading ? _createElement('div', {
                                            'className': 'option',
                                            'key': 'null-option',
                                            'disabled': true
                                        }, _translate(`select_loading`)) : null,
                                        !this.loading ? _map(this.entries, repeatEntry5.bind(this, isQualifierField)) : null
                                    ]) : null
                                ] : null, isQualifierField ? [
                                    _createElement('div', {
                                        'className': 'cm_select-qualifier-additional_details',
                                        'key': '39481'
                                    }, _translate(`ymm_bar_additional_details`)),
                                    _createElement('div', {
                                        'className': 'cm_select-qualifier',
                                        'key': '39483'
                                    }, _createElement('div', { 'className': 'cm_select-qualifier-header' }, _createElement('div', mergeProps({ 'className': 'cm_select-qualifier-title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), scopeDescription7.apply(this, [isQualifierField])), _createElement.apply(this, [
                                        'div',
                                        { 'className': 'cm_select-qualifier-value_repeater' },
                                        _map(this.entries, repeatEntry8.bind(this, isQualifierField))
                                    ]))
                                ] : null);
                            }
                            return scopeIsQualifierField9.apply(this, []);
                        }, { count: undefined })];
                }
                function onClick2() {
                    {
                        this.selectVehicle();
                        window.Convermax.completeVehicleSelection(this.vehicle);
                    }
                }
                return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_subtitle' }, _translate(`vehicle_dialog_please_select`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this))
                ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go button',
                    'onClick': onClick2.bind(this),
                    'disabled': !this.allowToSetVehicle,
                    'role': 'button',
                    'tabIndex': this.allowToSetVehicle ? '0' : '-1'
                }, '\n                ', _translate(`ymm_bar_submit`), '\n              '), _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear button button--secondary',
                    'onClick': this.discardVehicle,
                    'disabled': !this.allowToDiscardVehicle,
                    'role': 'button',
                    'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
                }, [_createElement('svg', {
                        'className': 'cm_icon',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '16',
                        'height': '16',
                        'viewBox': '0 0 16 16',
                        'fill': 'none',
                        'key': '116450'
                    }, _createElement('g', { 'clipPath': 'url(#clip0_2479_277)' }, _createElement('path', {
                        'd': 'M0.666748 2.66675V6.66675H4.66675',
                        'stroke': '#646B77',
                        'strokeWidth': '2',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M15.3333 13.3333V9.33325H11.3333',
                        'stroke': '#646B77',
                        'strokeWidth': '2',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M13.6601 5.99989C13.322 5.04441 12.7473 4.19016 11.9898 3.51683C11.2322 2.84351 10.3164 2.37306 9.32789 2.14939C8.33934 1.92572 7.31025 1.95612 6.33662 2.23774C5.363 2.51936 4.47658 3.04303 3.76008 3.75989L0.666748 6.66655M15.3334 9.33322L12.2401 12.2399C11.5236 12.9567 10.6372 13.4804 9.66354 13.762C8.68992 14.0437 7.66082 14.0741 6.67227 13.8504C5.68373 13.6267 4.76795 13.1563 4.01039 12.4829C3.25284 11.8096 2.67819 10.9554 2.34008 9.99989',
                        'stroke': '#646B77',
                        'strokeWidth': '2',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_2479_277' }, _createElement('rect', {
                        'width': '16',
                        'height': '16',
                        'fill': 'white'
                    }))))], ' ', _translate(`ymm_bar_clear`), '\n              ')))));
            }, {
                widgetName: 'undefined',
                items: undefined
            })]), _createElement('div', {
            'className': 'dialog-body',
            'data-cm-vehicle-dialog-view': 'limit',
            'hidden': true
        }, _createElement('div', { 'className': 'cm_vehicle-dialog_limit' }, [_createElement('svg', {
                'className': 'cm_icon cm_icon-exclamation',
                'height': '20',
                'viewBox': '0 0 256 255',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg',
                'key': '235400'
            }, _createElement('path', {
                'fillRule': 'evenodd',
                'clipRule': 'evenodd',
                'd': 'M112.098 0.528293C105.702 1.30529 89.9175 5.21029 83.6615 7.56329C64.7805 14.6653 49.2545 25.1013 34.5985 40.5423C-0.248547 77.2563 -9.69655 131.035 10.4785 177.833C17.3025 193.66 23.8655 203.124 37.5985 216.939C51.1805 230.602 61.9924 238.186 77.0984 244.649C104.915 256.549 138.414 258.074 166.974 248.741C177.998 245.139 194.9 236.465 203.598 229.946C212.511 223.266 228.177 206.84 233.748 198.332C262.341 154.67 262.457 100.262 234.048 56.8423C227.749 47.2143 210.42 29.3733 201.129 22.9513C185.936 12.4473 166.593 4.56829 148.217 1.39729C140.191 0.0112929 120.292 -0.466707 112.098 0.528293ZM146.598 101.364V157.864H127.598H108.598V101.364V44.8643H127.598H146.598V101.364ZM136.699 179.648C141.014 181.902 142.56 183.448 144.814 187.763C148.264 194.367 148.343 198.988 145.115 205.418C138.666 218.265 122.327 220.292 112.789 209.428C104.371 199.842 107.303 185.18 118.78 179.461C125.482 176.121 130.038 176.169 136.699 179.648Z'
            }))], _createElement('div', { 'className': 'cm_vehicle-dialog_limit-copy' }, '\n          ', _translate(`vehicle_dialog_limit_title`, {  count: 5  }), ' ', _translate(`vehicle_dialog_limit_message`), '\n        ')), _createElement('button', {
            'className': 'cm_vehicle-dialog_limit-continue button',
            'type': 'button',
            'onClick': onClick2.bind(this, showEditorInitially)
        }, '\n        ', _translate(`vehicle_dialog_continue`), '\n      '), _createElement('button', {
            'className': 'cm_vehicle-dialog_limit-cancel',
            'type': 'button',
            'onClick': this.close
        }, '\n        ', _translate(`vehicle_dialog_cancel`), '\n      '))));
    }
    return scopeShowEditorInitially3.apply(this, []);
}
        export const componentNames = ["cm:vehicleList","cm:filterInput","cm:vehicleWidget"]